// components
import GridPageAbstract from '../../GridPageAbstract';
import { ArrangeSquare2BulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class PaymentGatewaysPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'paymentGateways';
        this.Server = this.props.context.getState().server.paymentGateways;

        this.headerStartIcon = ArrangeSquare2BulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.searchFields = [
            'name',
            'partners.name'
        ];

        this.hiddenColumns = config?.hiddenColumns?.paymentGateways || [];


        this.Head = [
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'configuration',
                label: 'configuration',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'depositFee',
                label: 'depositFee',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'withdrawalFee',
                label: 'withdrawalFee',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'partnersId',
                label: 'partner',
                object: 'partner',
                alignRight: false,
                cell: 'Select',
                display: 'name',
                from: 'partners',
                filterCell: 'Context',
                filterBy: 'partners'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
